<form [formGroup]="form">
  <h3-checkbox-output-value-accessor
    [answerOptions]="answerOptions"
    [formControl]="form.controls.input"
    [name]="outputInfoStore.state().output.name"
    [trainingAnswers]="trainingAnswer$ | async"
  ></h3-checkbox-output-value-accessor>
</form>
